import React from 'react';
import { Col, Form, FormModal, Input, Row } from 'components';
import { ValidationErrors } from 'constants/validations';
import { useGeneralEditModal } from 'feature/clientTabs/payments/general/edit/useGeneralEditModal';

const { Item } = Form;

export interface IGeneralEditeModal {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit?: Record<string, any>;
}

export const GeneralEditeModal = (props: IGeneralEditeModal) => {
  const { modalState, onModalStateChange, dataToEdit } = props;
  const { onFinish, onCancel, contextHolder, form, isLoading } = useGeneralEditModal({
    modalState,
    onModalStateChange,
    dataToEdit,
  });
  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={'Update General Details'}
        width={680}
        okText={'Save'}
        open={modalState}
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={onFinish}
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Item
              name={'legalName'}
              label={'Legal Name*'}
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('Legal Name'),
                },
              ]}
            >
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={12}>
            <Item
              shouldUpdate={(prevValues: any, currentValues: any) => prevValues.legalName !== currentValues.legalName}
            >
              {({ getFieldValue }) => {
                return (
                  <Item name={'formationType'} label={'Formation Type'}>
                    <Input size={'large'} disabled={!getFieldValue('legalName')} />
                  </Item>
                );
              }}
            </Item>
          </Col>
          <Col span={12}>
            <Item
              shouldUpdate={(prevValues: any, currentValues: any) => prevValues.legalName !== currentValues.legalName}
            >
              {({ getFieldValue }) => {
                return (
                  <Item name={'taxNumber'} label={'Tax Number'}>
                    <Input size={'large'} disabled={!getFieldValue('legalName')} />
                  </Item>
                );
              }}
            </Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
};
